
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import { NRProject, NRProjectCase } from "@/lib/model/NRXQ/candidate";
import { Model } from "@/components/editor/ckeditor5";
import gateway from "@/lib/request/gateway";
import Template from "../../ai-builder/components/template.vue";

@Component({
  components: {}
})
export default class NRProjectCaseEdit extends Vue {
  @Prop() data!: any;
  @Prop() form!: any;
  @Prop({ type: Boolean, default: true }) edit!: boolean;
  @Prop({ type: Boolean, default: false }) isZhuBo!: boolean; //主播类型  有图片列表 上传视屏

  @Prop({ type: String, default: "" }) ossPrefix!: string;
  showBigImg = false;
  bigImgUrl = "";
  isVideo = false;
  uploading = false;
  uploadField = "";
  uploadFileMaxSize = 50; // 最大上传多少M
  fileTypeLimit: string[] = []; //类型限制
  percent = 0;
  percentImg = 0;
  showBar = false;
  showBarImg = false;

  getMultiInputShowArray(value: string) {
    const arr = value?.split(/(,|，|。|\n|\s)/);
    for (let i = arr.length; i >= 0; i--) {
      if (!arr[i] || arr[i].length < 2) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }
  openLink(link: string) {
    window.open(link);
  }

  uploadFile(data: { filename: string; file: File }) {
    const fileTypeFlag = this.uploadField; //上传后 判断字段类型用
    const { filename, file } = data;

    //文件类型检查
    const typeCheck = this.fileTypeLimit.find((d: string) => {
      return file.type.includes(d);
    });

    if (this.fileTypeLimit?.length && !typeCheck) {
      this.$message.warning(
        "请上传" + this.fileTypeLimit.join("、") + "格式的文件"
      );
      return;
    }
    console.log(file.size / 1024 / 1024);
    if (file.size / 1024 / 1024 > this.uploadFileMaxSize) {
      this.$message.error(
        `文件大小超出上限，最大允许${this.uploadFileMaxSize}M`
      );
      return;
    }
    //获取上传凭证
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        // 上传到oss
        const config: any = {
          onUploadProgress: (progressEvent: any) => {
            //progressEvent.loaded:已上传文件大小
            //progressEvent.total:被上传文件的总大小
            if (fileTypeFlag === "screenshotUrlList") {
              //上传图片
              this.percentImg = this.computePer(
                progressEvent.loaded,
                progressEvent.total
              );
            } else {
              this.percent = this.computePer(
                //上传视频
                progressEvent.loaded,
                progressEvent.total
              );
            }
          }
        };
        if (fileTypeFlag === "screenshotUrlList") {
          this.showBarImg = true;
        } else {
          this.showBar = true;
        }
        gateway
          .upload(postRes, file, config)
          .then((res: any) => {
            this.onUploadSuccess(res, fileTypeFlag);
          })
          .finally(() => {
            this.uploading = false;
            if (fileTypeFlag === "screenshotUrlList") {
              //上传图片
              this.percentImg = 0;
              this.showBarImg = false;
            } else {
              this.percent = 0;
              this.showBar = false;
            }

            // this.imageUrl = tempUrl;
            // this.$emit("change", this.imageUrl);
          });
      }
    });
  }

  async onUploadSuccess(file: any, fileTypeFlag: string) {
    if (fileTypeFlag === "screenshotUrlList") {
      // 图片列表
      // this.data[fileTypeFlag] = [file.object];
      this.data[fileTypeFlag].push(file.object);
    } else {
      // 其他文件
      this.data[fileTypeFlag] = file.object;
    }
    this.$message.success("上传成功");
  }
  computePer(i: number, ii: number) {
    const p = Number((Number(i) / Number(ii)).toFixed(3)) * 100;
    const t = String(p).split(".")[0];
    return Number(t);
  }
  delImg(i: number) {
    this.data.screenshotUrlList.splice(i, 1);
  }
  // 图片列表
  upImg() {
    this.uploadFileMaxSize = 50;
    this.uploadField = "screenshotUrlList";
    this.fileTypeLimit = ["png", "jpg", "bmp", "jpeg"];
  }
  // 视频
  upVideo() {
    this.uploadFileMaxSize = 1000;
    this.uploadField = "outVideoUrl";
    this.fileTypeLimit = [
      "mp4",
      "MP4",
      "avi",
      "AVI",
      "mov",
      "MOV",
      "rmvb",
      "RMVB",
      "rm",
      "RM",
      "flv",
      "FLV",
      "3gp",
      "3GP",
      "video"
    ];
  }
  //查看大图
  openImg(url: string, type = "") {
    this.isVideo = type === "video" ? true : false;
    this.bigImgUrl = url || "";
    this.showBigImg = true;
  }
}
